import React from 'react';
import { SiGooglemaps } from "react-icons/si";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebook } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

function Footer({ className = "" }) {
  return (
    <footer className={className}>
      <section class="footer-main">
    <div class="container">

    <div class="row">   
    </div>
        <div class="row">
            <div className='foot-01 col-md-3'>
            <h3>About</h3>
            <p>The State Board of Secondary Education registred by NCT Delhi  Regd. No. IN-DL411883131229667T the Board is to provide academic infrastructural, technical support and education on Intellectual Stimulation Syllabus for that specific course are produced by our scholars. </p>            
            </div>
           



            <div className='foot-02 col-md-3'>
            <h3>Quick Links</h3>
            <ul className='foot-menu'>             
              <li><a href="/">Home</a></li>              
              <li><a href="/10th-results">10th Results</a></li>
              <li><a href="/12th-results">12th Results</a></li>
              <li><a href="/download">Download</a></li>
              <li><a href="/contact">Contact Us</a></li>          
            </ul>            
            </div>

            <div className='foot-03 foot-address col-md-3'>
            <h3>Keep In Touch</h3>
            <ul className='foot-menu'>
              <li><SiGooglemaps /> Plot No. 290, Front Side, Sant Nagar, East of Kailash, New Delhi- 110065</li>
              <li><FaPhoneAlt /> <a href="tel:+91- 7835 9612 51">+91- 7835 9612 51</a></li>
              <li><MdEmail /> <a href="mailto:sbsedelhi@gmail.com">sbsedelhi@gmail.com</a></li>
              <li><MdEmail /> <a href="mailto:contact@sbsedelhi.com">contact@sbsedelhi.com</a></li>
            </ul> 
            </div>

            <div className='foot-04 col-md-3'>
            <h3>Follow Us</h3>
            <ul className='social-menu'>
              <li> <a href="#"><FaFacebook /> facebook</a></li>
              <li>  <a href="#"><FaYoutube /> Youtube</a></li>
              <li>  <a href="#"><FaInstagram /> Instagram</a></li>
            </ul>  
            </div>
         
        </div>
    <div class="row">
        <div class="col-md-12 copyright-text">
        Copyright © 2025 SBSE - Delhi, State Board Of Secondary Education, Delhi . All rights reserved.
        </div>
        </div>
    </div>
</section>
      </footer>
  )

}

export default Footer;
